import { useState } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';

const SectionText = ({ heading, body }) => (
  <div>
    <h2 className="font-heading text-2xl sm:text-3xl text-navy mb-4 leading-tight">{heading}</h2>
    <p className="text-navy/80 leading-[1.8] text-[16px] whitespace-pre-wrap">{body}</p>
  </div>
);
const SectionBullets = ({ heading, items }) => (
  <div>
    <h2 className="font-heading text-2xl sm:text-3xl text-navy mb-5 leading-tight">{heading}</h2>
    <ul className="space-y-3">
      {items.map((it, i) => (
        <li key={i} className="flex gap-3 text-navy/85 leading-relaxed text-[16px]">
          <span className="mt-2 w-1.5 h-1.5 rounded-full bg-gold flex-shrink-0"/> <span>{it}</span>
        </li>
      ))}
    </ul>
  </div>
);
const SectionCallout = ({ heading, body }) => (
  <div className="bg-gold/10 border-l-4 border-gold rounded-r-3xl p-7">
    <p className="text-[10px] uppercase tracking-widest text-gold font-semibold mb-3">Key insight</p>
    <h2 className="font-heading text-xl sm:text-2xl text-navy mb-3 leading-snug">{heading}</h2>
    <p className="text-navy/85 leading-[1.75] text-[16px]">{body}</p>
  </div>
);
const SectionExpandable = ({ heading, body }) => {
  const [open, setOpen] = useState(true);
  return (
    <div className="border border-navy/10 rounded-3xl overflow-hidden">
      <button
        onClick={() => setOpen(!open)}
        data-testid={`expand-${heading.slice(0, 20)}`}
        className="w-full flex items-center justify-between p-6 text-left hover:bg-beige/50 transition-smooth">
        <span className="font-heading text-xl text-navy">{heading}</span>
        {open ? <ChevronDown size={20} className="text-navy/50"/> : <ChevronRight size={20} className="text-navy/50"/>}
      </button>
      {open && (
        <div className="px-6 pb-6 pt-1 text-navy/85 leading-[1.75] text-[16px] whitespace-pre-wrap border-t border-navy/5">
          {body}
        </div>
      )}
    </div>
  );
};
const SectionExample = ({ heading, body }) => (
  <div className="bg-beige rounded-3xl p-7">
    <p className="text-[10px] uppercase tracking-widest text-navy/60 font-semibold mb-2">Practical example</p>
    <h2 className="font-heading text-xl text-navy mb-3">{heading}</h2>
    <p className="text-navy/85 leading-[1.75] text-[16px]">{body}</p>
  </div>
);
export function Section({ s }) {
  if (s.kind === 'text') return <SectionText {...s}/>;
  if (s.kind === 'bullets') return <SectionBullets {...s}/>;
  if (s.kind === 'callout') return <SectionCallout {...s}/>;
  if (s.kind === 'expandable') return <SectionExpandable {...s}/>;
  if (s.kind === 'example') return <SectionExample {...s}/>;
  return null;
}
